var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimeReceive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68055 13.7695V5.04226H11.3695C11.9235 5.04226 12.3979 5.15589 12.7928 5.38317C13.1905 5.61044 13.4959 5.92152 13.709 6.31641C13.922 6.71129 14.0286 7.16158 14.0286 7.66726C14.0286 8.16726 13.922 8.6147 13.709 9.00959C13.4959 9.40447 13.1905 9.71697 12.7928 9.94709C12.3979 10.1744 11.9249 10.288 11.3737 10.288H9.05555V9.79368H11.361C11.8098 9.79368 12.1933 9.70277 12.5115 9.52095C12.8297 9.33629 13.074 9.08487 13.2445 8.76669C13.4149 8.44567 13.5002 8.07919 13.5002 7.66726C13.5002 7.25249 13.4149 6.88459 13.2445 6.56357C13.074 6.24254 12.8283 5.99112 12.5073 5.8093C12.1891 5.62749 11.8056 5.53658 11.3567 5.53658H9.21322V13.7695H8.68055Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.402 19.9839L15.4525 18.9333L13.6388 17.0888H18.0447V15.5933H13.6388L15.4525 13.7488L14.402 12.6982L10.759 16.3411L14.402 19.9839Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimeReceive);
export default __webpack_public_path__ + "static/media/Prime_receive.2a14d280b9bf91b897d06f6fb3ab0c60.svg";
export { ForwardRef as ReactComponent };